import { animate } from 'animejs';

export function animateReveal(element: HTMLElement) {
  animate(element, {
    opacity: [0, 1],
    translateY: [16, 0],
    duration: 550,
    ease: 'out(3)',
  });

  // If the revealed element contains an SVG divider, animate the line stroke length
  const lines = element.querySelectorAll<SVGLineElement>('line');
  if (lines.length > 0) {
    animate(lines, {
      opacity: [0, 0.8],
      duration: 650,
      ease: 'outQuad',
    });
  }
}